//配置路由相关信息导入这个vue的目的是为了调用Vue.use()这个函数
import Vue from 'vue'
//使用路由前导入路由插件
import VueRouter from "vue-router";
//vue在使用插件前必须通过Vue.use(插件)这个来安装插件
Vue.use(VueRouter)
//创建路由的实例对象
const router = new VueRouter({
    mode: 'history',//去掉url中的#
    //router是一个数组，作用：定义hash地址与组件之间的对应关系
    routes: [
        {path: '/404', component: () => import('../views/404'), hidden: true},
        {path: '/', name: 'home', component: () => import('../views/Home')},
        {path: '/detail', name: 'detail', component: () => import('../views/NewsDetail')},
        {path: '/content', name: 'content', component: () => import('../views/Content')},
        {path: '/general', name: 'general', component: () => import('../views/General')},
        // 404 page must be placed at the end !!!
        { path: '*', redirect: '/404', hidden: true }
    ]
})
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

//向外共享路由的实例对象
export default router
